import { render } from "./TableContentLoader.vue?vue&type=template&id=da3076ea&scoped=true&ts=true"
import script from "./TableContentLoader.vue?vue&type=script&lang=ts"
export * from "./TableContentLoader.vue?vue&type=script&lang=ts"

import "./TableContentLoader.vue?vue&type=style&index=0&id=da3076ea&scoped=true&lang=css"

import exportComponent from "D:\\YellowBeardProject\\selecta\\selectashopadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-da3076ea"]])

export default __exports__